module.exports = __webpack_public_path__ + "static/assets/270a1a1b866c85472423355f04f3656b.png";